import { AccessRightFilterCollectionModel } from '@fi-shared/models';

export class RequestAccessSettingModel {
    Id = 0;
    AccessRightFilterCollection = new AccessRightFilterCollectionModel();

    constructor(data?) {
        if (data) this.Initialize(data);
    }

    Initialize(setting) {
        this.Id = setting.Id;
        this.AccessRightFilterCollection.InitializeAccessRightFilterCollection(setting.AccessRightFilterCollection);
    }
}
